var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackMagnifyingGlass = function SvgBlackMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.499a6.483 6.483 0 0 1-1.25 3.834l3.957 3.959a1.001 1.001 0 0 1-1.416 1.415l-3.956-3.959a6.464 6.464 0 0 1-3.835 1.25A6.499 6.499 0 1 1 8.5 2C12.091 2 15 4.909 15 8.499Zm-6.5 4.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z",
    fill: "#2C2C2B"
  })));
};
export default SvgBlackMagnifyingGlass;